import { DiwaAPI } from './client'

/** Mirrors POST /agent/ask — the Familiar reasons over your graph via Claude. */
export interface AskResponse {
  answer: string
}

/** Mirrors GET /agent/status. Reports whether a model key is set; never returns the key. */
export interface StatusResponse {
  key_configured: boolean
}

export class AgentAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  /**
   * Ask the familiar. `domains` scopes which regions of the graph enter its context; omit it to
   * use every domain you have. `focus` pins entity ids (@-mentions) — the backend guarantees them
   * and their 1-hop neighbours into the model's context even when the graph outgrows its budget.
   *
   * Throws ApiError(503) when no model key is configured, ApiError(502) when Claude is unreachable.
   */
  ask(question: string, opts?: { domains?: string[]; focus?: string[]; surface?: string }): Promise<AskResponse> {
    return this.api.post<AskResponse>('/agent/ask', {
      question,
      ...(opts?.domains ? { domains: opts.domains } : {}),
      ...(opts?.focus?.length ? { focus: opts.focus } : {}),
      ...(opts?.surface ? { surface: opts.surface } : {}),
    })
  }

  status(): Promise<StatusResponse> {
    return this.api.get<StatusResponse>('/agent/status')
  }
}
